type RouterIconType = Record<string, string>;
const RouterIcon: RouterIconType = {
  "/vehilce-sales": "CarOutlined", // 车辆销售
  "/basic-vehicle": "ContainerOutlined", // 基础档案
  "/insurance-management": "InsuranceOutlined", // 保险管理
  "/approval-fee": "DollarOutlined", // 费用审批
  "/driver-management": "TeamOutlined", // 司机管理
  "/vehicle-management": "CarOutlined", // 车辆管理
  "/one-car-one-gear": "ProfileOutlined", // 一车一档
  "/driver-recruit": "UsergroupAddOutlined", // 司机招募
  "/oil-cost-management": "FireOutlined", // 油耗管理
  "/vehicle-cost-management": "PoundOutlined", // 成本管理
  "/financing-management": "TrophyOutlined", // 融资管理
  "/accident-manage": "AlertOutlined", // 事故管理
  "/maintenance-management": "ToolOutlined", // 维修保养
};
export default RouterIcon;
